<template>
    <settings-property :label="resource('JourneyBuilder_FilterSettings_Arrival_DisplayName')" icon="fas fa-plane-arrival">
        <template #input="{id}">
            <v-select class='form-control'
                      v-model="selectedValue"

                      :input-id="id"
                      :options="availableConditions"
                      :disabled="!canWrite || availableConditions.length === 0"
                      :clearable="false"

                      label='name'

                      searchable
                      filterable
                      taggable

                      close-on-select
            >
                <div slot='no-options' />
            </v-select>
        </template>
    </settings-property>
</template>

<script>

import guid from '@core/Util/Mixins/guid';
import resources from '@core/Util/Mixins/resources';
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

import SettingsProperty from "../SettingsProperty";
import VSelect from 'vue-select';

export default {
    name: 'touchpoint-arrival',
    components: {
        VSelect,
        SettingsProperty
    },
    mixins: [resources, guid, permissionsMixin],
    created() {
        const vm = this;
        vm.selectedValue = vm.availableConditions.find(v => v.id === vm.value) || '';
    },
    watch: {
        selectedValue(value){
            this.$emit('input', value ? value.id : '');
        },
        availableConditions(value) {
            const valueAvailable = value.indexOf(this.selectedValue) !== -1;
            
            if(!valueAvailable) {
                this.selectedValue = null;
            }
        }
    },
    data() {
        return {
            selectedValue: null,
            elementName: 'Arrival'
        }
    },
    props: {
        value: {
            type: String,
            default: null
        },
        availableConditions: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>

</style>